@if (
  {
    items: entries$!
  };
  as context
) {
  <div [ngClass]="{ 'limit-min-width': forceTextWrap }">
    <span class="visually-hidden" [id]="komponentenId + '_label'">{{ label }}</span>
    <div
      [style.maxHeight.px]="(isTablet$ | async) ? null : maxHeight"
      class="scrollbar"
      role="listbox"
      [attr.aria-labelledby]="komponentenId + '_label'"
      aria-multiselectable="true"
      [attr.aria-activedescendant]="
        focusedIndex !== -1 ? komponentenId + '_list_item_' + focusedIndex : null
      "
      (keyup.arrowup)="moveUp()"
      (keyup.arrowdown)="moveDown()"
      (keyup.space)="this.setFocusedItem()"
      (focus)="focusin()"
      (click)="onListClick()"
      tabindex="0"
    >
      @for (item of context.items; track trackByItemKey(i, item); let i = $index) {
        <div
          #listItem
          class="form-check d-flex"
          [attr.data-index]="determineIndex(i)"
          [attr.id]="komponentenId + '_list_item_' + i"
          role="option"
          [attr.aria-disabled]="isDisabled(item, false)"
          [attr.aria-selected]="getIsSelected(i)"
          [ngClass]="{ focused: i === focusedIndex }"
          [class.lastSelectedItem]="pinSelectedAtTop && isLastSelectedElement(context.items, i)"
        >
          @let itemKey = getItemKeyWithoutWhitespace(item);
          <input
            tabindex="-1"
            type="checkbox"
            (change)="onItemClick(i)"
            [disabled]="isDisabled(item, false)"
            [checked]="item.selected"
            class="now-checkbox"
            id="{{ komponentenId }}_checkbox_{{ itemKey }}"
            [attr.aria-labelledby]="komponentenId + '_checkbox_label_' + itemKey"
          />
          <label
            aria-hidden="true"
            id="{{ komponentenId }}_checkbox_label_{{ itemKey }}"
            for="{{ komponentenId }}_checkbox_{{ itemKey }}"
            [ngClass]="{ 'text-wrap': (isPhablet$ | async) || forceTextWrap }"
            [attr.aria-label]="item.ariaLabel"
          >
            @if (truncate) {
              <span [innerHTML]="item.label | truncate: 2 : ' …' : true"></span>
            }
            @if (!truncate) {
              <span [innerHTML]="item.label"></span>
            }
          </label>
          @if (item.modal; as modal) {
            <button
              [id]="modal.id + '_infobutton'"
              [attr.data-bs-target]="'#' + modal.id"
              data-bs-toggle="modal"
              [attr.aria-label]="modal.ariaLabel"
              class="now-btn now-btn-tertiary now-btn-icon-only now-icon-info-fill"
            ></button>
          }
        </div>
      }
    </div>
  </div>
}
@if (!sortedFilterList || sortedFilterList.length === 0) {
  <div
    id="{{ komponentenId }}_keineErgebnisse"
    class="keine-ergebnisse"
    [innerHTML]="'keine Ergebnisse'"
  ></div>
}
